// loader.interceptors.ts
import { Injectable } from "@angular/core";
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { LoaderService } from "../../components/loader/loader.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: LoaderService) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    if (
      this.requests.length == 1 &&
      this.requests.find((x) => x.url.includes("openid-connect/token"))
    ) {
    } else
      this.loaderService.loaderData.next({
        loading: this.requests.length > 0,
        isAdmin: this.RequestContainAdminpath(),
      });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requests.push(req);
    if (
      this.requests.length == 1 &&
      this.requests.find((x) => x.url.includes("openid-connect/token"))
    ) {
    } else {
      this.loaderService.loaderData.next({
        loading: true,
        isAdmin: this.RequestContainAdminpath(),
      });
    }
    return Observable.create((observer: any) => {
      const subscription = next.handle(req).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        (err) => {
          console.log("error returned");
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
  RequestContainAdminpath(): boolean {
    if (
      this.requests.length == 1 &&
      this.requests.find((x) => x.url.toLocaleLowerCase().includes("/admin"))
    )
      return true;
    else return false;
  }
}
